import React, { useState } from "react";
import layoutStyles from "../PanelUser/PanelLayout.module.css";
import styles from "./HistorialMedico.module.css";
import axiosInstance from "../../api/axiosConfig";
import {
  PanelSidebar,
  PanelHeader,
  useUserData,
  getTipoBadge,
  getEstadoBadge,
  formatDate,
  MOCK_USER,
} from "../PanelUser/PanelShared";

const MOCK_HISTORIAL = [
  {
    id: 1,
    specialty: "Cardiología",
    professional_name: "Roberto",
    professional_last_name: "Vega",
    date: "2026-02-28",
    type: "Teleconsulta",
    status: "Completada",
    diagnosis: "Hipertensión leve controlada.",
    notes: "Se recomienda dieta baja en sodio y actividad física moderada.",
  },
  {
    id: 2,
    specialty: "Dermatología",
    professional_name: "Patricia",
    professional_last_name: "Lima",
    date: "2026-02-16",
    type: "A domicilio",
    status: "Completada",
    diagnosis: "Dermatitis de contacto.",
    notes: "Se prescribió crema corticoesteroide. Revisión en 2 semanas.",
  },
  {
    id: 3,
    specialty: "Medicina General",
    professional_name: "Marco",
    professional_last_name: "Castro",
    date: "2026-01-30",
    type: "Teleconsulta",
    status: "Completada",
    diagnosis: "Gripe estacional.",
    notes: "Reposo, hidratación y antipiréticos de ser necesario.",
  },
  {
    id: 4,
    specialty: "Fisioterapia",
    professional_name: "Carmen",
    professional_last_name: "López",
    date: "2026-01-15",
    type: "Presencial",
    status: "Completada",
    diagnosis: "Lumbalgia mecánica.",
    notes: "6 sesiones de rehabilitación prescritas.",
  },
  {
    id: 5,
    specialty: "Pediatría",
    professional_name: "Ana",
    professional_last_name: "Torres",
    date: "2025-12-10",
    type: "Teleconsulta",
    status: "Completada",
    diagnosis: "Control pediátrico rutinario.",
    notes: "Desarrollo normal. Próximas vacunas en 6 meses.",
  },
  {
    id: 6,
    specialty: "Oftalmología",
    professional_name: "Jorge",
    professional_last_name: "Ramos",
    date: "2025-11-05",
    type: "Presencial",
    status: "Cancelada",
    diagnosis: "—",
    notes: "Cita cancelada por el paciente.",
  },
];

function getInitials(a = "", b = "") {
  return `${a[0] || ""}${b[0] || ""}`.toUpperCase() || "?";
}

export default function HistorialMedico() {
  const user = useUserData(axiosInstance) || MOCK_USER;
  const [search, setSearch] = useState("");
  const [selected, setSelected] = useState(null);

  const filtered = MOCK_HISTORIAL.filter(
    (h) =>
      h.specialty.toLowerCase().includes(search.toLowerCase()) ||
      h.professional_name.toLowerCase().includes(search.toLowerCase()) ||
      h.professional_last_name.toLowerCase().includes(search.toLowerCase()),
  );

  const completadas = MOCK_HISTORIAL.filter((h) => h.status === "Completada").length;
  const uniqueSpecs = new Set(MOCK_HISTORIAL.map((h) => h.specialty)).size;
  const enRevision = 0;

  return (
    <div className={layoutStyles.panelPage}>
      <PanelSidebar user={user} />

      <main className={layoutStyles.main}>
        <PanelHeader label="Mi panel" title="Historial médico" user={user} />
        <p className={styles.subtitle}>Registro completo de consultas y diagnósticos.</p>

        {/* Stats */}
        <div className={layoutStyles.statsGrid}>
          <div className={layoutStyles.statCard}>
            <p className={layoutStyles.statValue}>{MOCK_HISTORIAL.length}</p>
            <p className={layoutStyles.statTitle}>Total consultas</p>
          </div>
          <div className={layoutStyles.statCard}>
            <p className={layoutStyles.statValue}>{uniqueSpecs}</p>
            <p className={layoutStyles.statTitle}>Especialidades</p>
          </div>
          <div className={layoutStyles.statCard}>
            <p className={layoutStyles.statValue}>{enRevision}</p>
            <p className={layoutStyles.statTitle}>En revisión</p>
          </div>
          <div className={layoutStyles.statCard}>
            <p className={`${layoutStyles.statValue} ${layoutStyles.teal}`}>{completadas}</p>
            <p className={layoutStyles.statTitle}>Completadas</p>
          </div>
        </div>

        {/* Buscador */}
        <div className={layoutStyles.card}>
          <input
            className={styles.searchInput}
            placeholder="Buscar por especialidad, médico o diagnóstico..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className={styles.twoCol}>
          {/* Lista */}
          <div className={layoutStyles.card}>
            {filtered.length === 0 ? (
              <p className={layoutStyles.emptyState}>No se encontraron resultados.</p>
            ) : (
              filtered.map((h) => (
                <div
                  key={h.id}
                  className={`${styles.histRow} ${selected?.id === h.id ? styles.histRowActive : ""}`}
                  onClick={() => setSelected(h)}
                >
                  <div className={styles.histLeft}>
                    <div className={styles.histAvatar}>
                      {getInitials(h.professional_name, h.professional_last_name)}
                    </div>
                    <div>
                      <p className={styles.histSpec}>{h.specialty}</p>
                      <p className={styles.histDoc}>
                        Dr/a. {h.professional_name} {h.professional_last_name}
                      </p>
                      <p className={styles.histDate}>{formatDate(h.date)}</p>
                    </div>
                  </div>
                  <div className={styles.histMeta}>
                    {getTipoBadge(h.type)}
                    {getEstadoBadge(h.status)}
                  </div>
                </div>
              ))
            )}
          </div>

          {/* Detalle */}
          <div className={layoutStyles.card}>
            {!selected ? (
              <p className={layoutStyles.emptyState}>
                Seleccioná una consulta para ver el detalle.
              </p>
            ) : (
              <div className={styles.detail}>
                <div className={styles.detailHeader}>
                  <div className={styles.detailAvatar}>
                    {getInitials(selected.professional_name, selected.professional_last_name)}
                  </div>
                  <div>
                    <p className={styles.detailSpec}>{selected.specialty}</p>
                    <p className={styles.detailDoc}>
                      Dr/a. {selected.professional_name} {selected.professional_last_name}
                    </p>
                  </div>
                </div>
                <div className={styles.detailRow}>
                  <span>Fecha</span>
                  <strong>{formatDate(selected.date)}</strong>
                </div>
                <div className={styles.detailRow}>
                  <span>Tipo</span>
                  {getTipoBadge(selected.type)}
                </div>
                <div className={styles.detailRow}>
                  <span>Estado</span>
                  {getEstadoBadge(selected.status)}
                </div>
                {selected.diagnosis && selected.diagnosis !== "—" && (
                  <div className={styles.detailSection}>
                    <p className={styles.detailSectionTitle}>Diagnóstico</p>
                    <p className={styles.detailSectionText}>{selected.diagnosis}</p>
                  </div>
                )}
                {selected.notes && (
                  <div className={styles.detailSection}>
                    <p className={styles.detailSectionTitle}>Observaciones</p>
                    <p className={styles.detailSectionText}>{selected.notes}</p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
}
